// import { useEffect, useState } from "react";
// import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
// import Button from "../../components/button/Button";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   fetchList,
//   fetchSubscriptionDataById,
//   setPlanDetails,
//   updateSubscription,
//   updateSubscriptionStatus,
// } from "../../features/subscriptionSlice";
// import {
//   basicModalShowHide,
//   largeModalShowHide,
//   setTitle,
// } from "../../features/modalSlice";
// import { BasicModal, LargeModal } from "../../components/modal/ModalUI";
// import SubscriptionDetails from "./SubscriptionDetails";
// import SubscriptionModal from "./SubscriptionModal";
// import { can } from "../../utils/permission.util";

// const Subscription = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { listData } = useSelector((state) => state.subscription);
//   const [searchText, setSearchText] = useState("");
//   const [modalTitle, setModalTitle] = useState("");
//   const [isOpenModal, setIsOpenModal] = useState(false);
//   // Pagination State
//   const [limit, setLimit] = useState(10); // Default limit
//   const [offset, setOffset] = useState(0); // Offset starts at 0

//   useEffect(() => {
//     const payload = { offset, limit, searchText: "" };
//     dispatch(fetchList(payload));
//   }, [offset, searchText]);

//   // console.log("listData >>> ", listData);

//     dispatch(
//       fetchSubscriptionDataById({
//         id: id,
//       }),
//     );
//     setIsOpenModal(true);
//     setModalTitle("Edit Subscription Plan");
//   }

//   const viewMoreDetails = (i, body) => {
//     const list = listData[i];
//     if (body === "details") {
//       dispatch(setPlanDetails(list));
//       dispatch(setTitle("Subscription Details"));
//     }
//     dispatch(largeModalShowHide());
//   };

//   const addCompany = () => {
//     // dispatch(basicModalShowHide());
//     // dispatch(setTitle("Add New Subscription Plan"));
//     setIsOpenModal(true);
//     setModalTitle("Add New Subscription Plan");
//   };

//   function closeOpenModal() {
//     setIsOpenModal(false);
//   }

//   function truncateDescription(description) {
//     if (!description) return ""; // Handle null, undefined, or empty values
//     return description.length > 100
//       ? description.substring(0, 100) + "..."
//       : description;
//   }

//   return (
//     <div id="main" className="main">
//       <Breadcrumb page="Subscription List" />
//       <section className="section">
//         <div className="row mb-3">
//           <div className="col-sm-6 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
//             <div className="d-flex align-items-center gap-2 item_list">
//               <h6 className="card-title m-0 p-0">Subscription List</h6>
//               {/* <input className='form-control' placeholder='search' type='text' name='search' value={searchText} onChange={(e) => setSearchText(e.target.value)} /> */}
//             </div>
//             {can("/subscription", "create") && (
//               <Button
//                 className="btn btn-sm btn-outline-primary me-2"
//                 title="Add Plan"
//                 onClick={() => addCompany()}
//               >
//                 <i className="fa-solid fa-plus" />
//               </Button>
//             )}
//           </div>
//         </div>
//         <table className="table table-bordered">
//           <thead>
//             <tr>
//               <th scope="col" className="text-center fs-7">
//                 Plan Name
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Description
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Monthly Cost
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Annual Cost
//               </th>
//               <th scope="col" className="text-center fs-7">
//                 Action
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {listData && listData.length
//               ? listData.map((item, i) => (
//                   <tr key={`subscriptionList-${i}`}>
//                     <td className="text-center fs-7" width="10%">
//                       {item.name}
//                     </td>
//                     <td className="text-center fs-7 align-middle">
//                       <span title={item.description}>
//                         {truncateDescription(item.description)}
//                       </span>
//                     </td>
//                     {item.id === 1 ? (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_monthly === 0 || item.price_monthly === null
//                           ? "Free"
//                           : "$ " + item.price_monthly}
//                       </td>
//                     ) : (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_monthly === 0 || item.price_monthly === null
//                           ? "--"
//                           : "$ " + item.price_monthly}
//                       </td>
//                     )}
//                     {item.id === 1 ? (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_annually === 0 ||
//                         item.price_annually === null
//                           ? "Free"
//                           : "$ " + item.price_annually}
//                       </td>
//                     ) : (
//                       <td className="text-center fs-7 align-middle">
//                         {item.price_annually === 0 ||
//                         item.price_annually === null
//                           ? "--"
//                           : "$ " + item.price_annually}
//                       </td>
//                     )}
//                     <td className="text-center fs-7 align-middle">
//                       <Button
//                         className="btn btn-outline-success btn-sm fs-7 me-2"
//                         onClick={() => viewMoreDetails(i, "details")}
//                       >
//                         <i className="fa-regular fa-eye"></i>
//                       </Button>
//                       {item?.status === 1 ? (
//                         can("/subscription", "create") && (
//                           <>
//                             <Button
//                               className="btn btn-outline-success btn-sm fs-7 me-2"
//                               onClick={() => itemStatusChange(item.id, 0)}
//                               title="Inactive Plan"
//                             >
//                               <i class="fa-solid fa-cloud-arrow-up"></i>
//                             </Button>
//                           </>
//                         )
//                       ) : (
//                         can("/subscription", "create") && (
//                           <Button
//                             className="btn btn-outline-danger btn-sm fs-7 me-2"
//                             onClick={() => itemStatusChange(item.id, 1)}
//                             title="Active Plan"
//                           >
//                             <i class="fa-solid fa-cloud-arrow-up"></i>
//                           </Button>
//                         )
//                       )}
//                       {can("/subscription", "create") && (
//                         <Button
//                           className="btn btn-outline-success btn-sm fs-7 me-2"
//                           title="Edit Subscription"
//                           onClick={() => editPlan(item.id)}
//                         >
//                           <i className="fa-solid fa-pen-to-square"></i>
//                         </Button>
//                       )}
//                       {can("/subscription", "delete") && (
//                         <>
//                           <Button
//                             className="btn btn-outline-danger btn-sm fs-7 me-2"
//                             onClick={() => itemStatusChange(item.id, 2)}
//                             title="Delete Subscription"
//                           >
//                             <i class="fa-regular fa-trash-can"></i>
//                           </Button>
//                         </>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               : null}
//           </tbody>
//         </table>
//       </section>
//       {isOpenModal && (
//         <>
//           <div
//             className="modal-backdrop fade show"
//             style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
//           ></div>
//           <div
//             class="modal fade show subscription-modal-width"
//             id="subscriptionModal"
//             tabindex="-1"
//             aria-modal="true"
//             role="dialog"
//             style={{ display: "block" }}
//           >
//             <div class="modal-dialog">
//               <div class="modal-content">
//                 <div class="modal-header">
//                   <h5 class="modal-title">{modalTitle}</h5>
//                   <button
//                     type="button"
//                     class="btn-close"
//                     data-bs-dismiss="modal"
//                     onClick={closeOpenModal}
//                   ></button>
//                 </div>
//                 <div class="modal-body">
//                   <SubscriptionModal closeModal={closeOpenModal} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <LargeModal>
//         <SubscriptionDetails />
//       </LargeModal>
//     </div>
//   );
// };
// export default Subscription;













import { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import Button from "../../components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchList,
  fetchSubscriptionDataById,
  makeDefaultSubscription,
  setPlanDetails,
  updateSubscriptionStatus,
} from "../../features/subscriptionSlice";
import { largeModalShowHide, setTitle } from "../../features/modalSlice";
import { LargeModal } from "../../components/modal/ModalUI";
import SubscriptionDetails from "./SubscriptionDetails";
import SubscriptionModal from "./SubscriptionModal";
import { can } from "../../utils/permission.util";
import { errorToastify } from "../../utils/toastify.util";
import {
  RowActionButton,
  RowActionIcons,
  RowActions,
} from "../../components/data-table/RowActions";

// ✅ NEW
import SubscriptionUserMapModal from "./SubscriptionUserMapModal";

const Subscription = () => {
  const dispatch = useDispatch();
  const { listData } = useSelector((state) => state.subscription);

  const searchText = "";
  const [selectedPlanType, setSelectedPlanType] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [modalTitle, setModalTitle] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);

  // ✅ NEW: modal type
  const [modalType, setModalType] = useState("plan"); // plan | map
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

  // One confirmation dialog for default / publish / unpublish / delete.
  const [confirm, setConfirm] = useState(null);
  const [confirmBusy, setConfirmBusy] = useState(false);

  // shortcut: no pager on this page, so ask for a large page; upgrade if plans ever pass 100.
  const limit = 100;
  const offset = 0;

  useEffect(() => {
    const statusPayload = selectedStatus === "all" ? "" : selectedStatus;
    const payload = { offset, limit, searchText, status: statusPayload };
    dispatch(fetchList(payload));
  }, [offset, searchText, dispatch, limit, selectedStatus]);

  function itemStatusChange(id, status) {
    return dispatch(updateSubscriptionStatus({ id, status }));
  }

  function closeConfirm() {
    if (confirmBusy) return;
    setConfirm(null);
  }

  function askDefault(item) {
    if (Number(item?.defaultplan ?? 0) === 1) return;
    setConfirm({
      title: "Make default plan",
      body: (
        <>
          Make <strong>{item.name}</strong> ({item.plan_type === "yearly" ? "Annual" : "Monthly"}) the default plan?
          New users without a plan will be placed on it.
        </>
      ),
      label: "Make default",
      btn: "btn-warning",
      run: () => dispatch(makeDefaultSubscription({ id: item.id, offset, limit, searchText })),
    });
  }

  function askStatus(item, status) {
    const name = <strong>{item.name}</strong>;
    const copy = {
      0: {
        title: "Unpublish plan",
        body: <>Unpublish {name}? It disappears from the store. People already on it keep it until it ends.</>,
        label: "Unpublish",
        btn: "btn-warning",
      },
      1: {
        title: "Publish plan",
        body: <>Publish {name} to the store so people can buy it?</>,
        label: "Publish",
        btn: "btn-primary",
      },
      2: {
        title: "Delete plan",
        body: <>Delete {name}? This removes it from the store and can't be undone here.</>,
        label: "Delete plan",
        btn: "btn-danger",
      },
    }[status];
    setConfirm({ ...copy, run: () => itemStatusChange(item.id, status) });
  }

  async function runConfirm() {
    if (!confirm || confirmBusy) return;
    setConfirmBusy(true);
    try {
      const res = await confirm.run();
      // Keep the dialog open on failure so the admin sees the error toast and can retry or cancel.
      const failed = res?.meta?.requestStatus === "rejected" || res?.payload?.success === false;
      if (failed) errorToastify(res?.payload?.message);
      else setConfirm(null);
    } finally {
      setConfirmBusy(false);
    }
  }

  function editPlan(id) {
    dispatch(fetchSubscriptionDataById({ id }));
    setSelectedSubscriptionId(id);
    setModalType("plan");
    setIsOpenModal(true);
    setModalTitle("Edit Subscription Plan");
  }

  // ✅ NEW: Map modal open
  function mapUser(id) {
    setSelectedSubscriptionId(id);
    setModalType("map");
    setIsOpenModal(true);
    setModalTitle("Map Users to Subscription");
  }

  const filteredList = (listData || []).filter((item) => {
    if (selectedPlanType === "all") {
      return true;
    }
    return item.plan_type === selectedPlanType;
  });

  const viewMoreDetails = (item, body) => {
    if (body === "details") {
      dispatch(setPlanDetails(item));
      dispatch(setTitle("Subscription Details"));
    }
    dispatch(largeModalShowHide());
  };

  const addCompany = () => {
    setSelectedSubscriptionId(null);
    setModalType("plan");
    setIsOpenModal(true);
    setModalTitle("Add New Subscription Plan");
  };

  const closeOpenModal = useCallback(() => {
    setIsOpenModal(false);
    setModalType("plan");
    setSelectedSubscriptionId(null);
  }, []);

  function truncateDescription(description) {
    if (!description) return "";
    return description.length > 100
      ? description.substring(0, 100) + "..."
      : description;
  }

  return (
    <div id="main" className="main">
      <Breadcrumb page="Subscription List" />

      <section className="section">
        <div className="row mb-3">
          <div className="col-sm-6 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2 item_list">
              <h6 className="card-title m-0 p-0">Subscription List</h6>
            </div>

            {can("/subscription", "create") && (
              <Button
                className="btn btn-sm btn-outline-primary me-2"
                title="Add Plan"
                onClick={() => addCompany()}
              >
                <i className="fa-solid fa-plus" />
              </Button>
            )}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-4 col-md-3 col-lg-2">
            <label className="form-label fs-7">Plan Type</label>
            <select
              className="form-select"
              value={selectedPlanType}
              onChange={(e) => setSelectedPlanType(e.target.value)}
            >
              <option value="all">All</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Annual</option>
            </select>
          </div>

          <div className="col-sm-4 col-md-3 col-lg-2">
            <label className="form-label fs-7">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col" className="text-center fs-7">
                Plan Name
              </th>
              <th scope="col" className="text-center fs-7">
                Plan Type
              </th>
              <th scope="col" className="text-center fs-7">
                Description
              </th>
              <th scope="col" className="text-center fs-7">
                Monthly Cost
              </th>
              <th scope="col" className="text-center fs-7">
                Annual Cost
              </th>
              <th scope="col" className="text-center fs-7">
                Status
              </th>
              <th scope="col" className="text-center fs-7">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {filteredList.length
              ? filteredList.map((item, i) => (
                  <tr key={`subscriptionList-${i}`}>
                    <td className="text-center fs-7" width="10%">
                      {item.name}
                    </td>

                    <td className="text-center fs-7 align-middle">
                      {item.plan_type === "yearly" ? "Annual" : "Monthly"}
                    </td>

                    <td className="text-center fs-7 align-middle">
                      <span title={item.description}>
                        {truncateDescription(item.description)}
                      </span>
                    </td>

                    {item.id === 1 ? (
                      <td className="text-center fs-7 align-middle">
                        {item.price_monthly === 0 || item.price_monthly === null
                          ? "Free"
                          : "$ " + item.price_monthly}
                      </td>
                    ) : (
                      <td className="text-center fs-7 align-middle">
                        {item.price_monthly === 0 || item.price_monthly === null
                          ? "--"
                          : "$ " + item.price_monthly}
                      </td>
                    )}

                    {item.id === 1 ? (
                      <td className="text-center fs-7 align-middle">
                        {item.price_annually === 0 ||
                        item.price_annually === null
                          ? "Free"
                          : "$ " + item.price_annually}
                      </td>
                    ) : (
                      <td className="text-center fs-7 align-middle">
                        {item.price_annually === 0 ||
                        item.price_annually === null
                          ? "--"
                          : "$ " + item.price_annually}
                      </td>
                    )}

                    <td className="text-center fs-7 align-middle">
                      <span className={`badge ${item?.status === 1 ? "bg-success" : "bg-secondary"}`}>
                        {item?.status === 1 ? "Published" : "Unpublished"}
                      </span>
                      {Number(item?.defaultplan ?? 0) === 1 && (
                        <span className="badge bg-warning text-dark ms-1">Default</span>
                      )}
                    </td>

                    <td className="text-center fs-7 align-middle">
                      <RowActions className="flex-nowrap">
                        <RowActionButton
                          label="View"
                          iconClass={RowActionIcons.view}
                          variant="outline-success"
                          onClick={() => viewMoreDetails(item, "details")}
                        />
                        {item?.status === 1
                          ? can("/subscription", "create") && (
                              <RowActionButton
                                label={
                                  Number(item?.defaultplan ?? 0) === 1
                                    ? "The default plan can't be unpublished"
                                    : "Unpublish"
                                }
                                iconClass={RowActionIcons.unpublish}
                                variant="outline-secondary"
                                disabled={Number(item?.defaultplan ?? 0) === 1}
                                onClick={() => askStatus(item, 0)}
                              />
                            )
                          : can("/subscription", "create") && (
                              <RowActionButton
                                label="Publish to store"
                                iconClass={RowActionIcons.publish}
                                variant="outline-primary"
                                onClick={() => askStatus(item, 1)}
                              />
                            )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label="Edit"
                            iconClass={RowActionIcons.edit}
                            variant="outline-success"
                            onClick={() => editPlan(item.id)}
                          />
                        )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label={
                              Number(item?.defaultplan ?? 0) === 1
                                ? "Default plan"
                                : "Set default"
                            }
                            iconClass={RowActionIcons.star}
                            variant={
                              Number(item?.defaultplan ?? 0) === 1
                                ? "warning"
                                : "outline-warning"
                            }
                            onClick={() => askDefault(item)}
                            disabled={Number(item?.defaultplan ?? 0) === 1}
                          />
                        )}
                        {can("/subscription", "create") && (
                          <RowActionButton
                            label="Assign subscription"
                            iconClass={RowActionIcons.crown}
                            variant="outline-success"
                            onClick={() => mapUser(item.id)}
                          />
                        )}
                        {can("/subscription", "delete") && (
                          <RowActionButton
                            label={
                              Number(item?.defaultplan ?? 0) === 1
                                ? "The default plan can't be deleted"
                                : "Delete"
                            }
                            iconClass={RowActionIcons.delete}
                            variant="outline-danger"
                            disabled={Number(item?.defaultplan ?? 0) === 1}
                            onClick={() => askStatus(item, 2)}
                          />
                        )}
                      </RowActions>
                    </td>
                  </tr>
                ))
              : (
                  <tr>
                    <td className="text-center fs-7 text-muted py-4" colSpan={7}>
                      No plans match these filters.
                    </td>
                  </tr>
                )}
          </tbody>
        </table>
      </section>

      {/* ✅ SINGLE MODAL, BODY changes by modalType (keeps your flow) */}
      {isOpenModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
          ></div>

          <div
            className="modal fade show subscription-modal-width"
            id="subscriptionModal"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{modalTitle}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={closeOpenModal}
                  ></button>
                </div>

                <div className="modal-body">
                  {modalType === "plan" ? (
                    <SubscriptionModal closeModal={closeOpenModal} />
                  ) : (
                    <SubscriptionUserMapModal
                      closeModal={closeOpenModal}
                      subscriptionId={selectedSubscriptionId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <LargeModal>
        <SubscriptionDetails />
      </LargeModal>

      {confirm && (
        <>
          <div className="modal-backdrop fade show" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }} />
          <div className="modal fade show subscription-modal-width" tabIndex="-1" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{confirm.title}</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeConfirm} disabled={confirmBusy} />
                </div>
                <div className="modal-body">
                  <p className="mb-0">{confirm.body}</p>
                </div>
                <div className="modal-footer">
                  <Button className="btn btn-secondary" onClick={closeConfirm} disabled={confirmBusy}>
                    Cancel
                  </Button>
                  <Button className={`btn ${confirm.btn}`} onClick={runConfirm} disabled={confirmBusy}>
                    {confirmBusy ? "Working…" : confirm.label}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Subscription;
